<block-ui>
  <div class="box">
    <div class="box-header p-3">
      <div class="row col-sm-8">
        <div class="col-sm-4" style="width: 80%!important;margin-bottom: -2%!important;">
          <table class="table col-sm-4">
            <tbody>
              <tr>
                <td class="font-weight-bold colon">
                  {{'Store #' | translate}}
                </td>
                <td>{{orderdetailsresponse.storeNumber}}</td>
                <td class="font-weight-bold colon">
                  {{'DC Location' | translate}}
                </td>
                <td>{{orderdetailsresponse.dcAddress}}</td>
              </tr>

              <tr>
                <td class="font-weight-bold colon">
                  {{'RC #' | translate}}
                </td>
                <td>{{orderdetailsresponse.purchaseOrder}}</td>

                <td class="font-weight-bold colon">
                  {{'RC Date' | translate}}
                </td>
                <td>{{orderdetailsresponse.poCreatedTime | date : dateTimeFormat : '' : 'fr'}}</td>
              </tr>
              <tr>
                <td class="font-weight-bold colon">
                  {{'Status' | translate}}
                </td>
                <td>
                  @if (orderdetailsresponse.status !== 5) {
                    <label>  {{ orderdetailsresponse.statusName | translate}} </label>
                  }
                  @if (orderdetailsresponse.status === 5) {
                    <label>  {{ 'Signed' | translate}} </label>
                  }

                </td>

                <td class="font-weight-bold colon">
                  {{'Date Received' | translate}}
                </td>
                <td>
                  <form [formGroup]="rcSummaryForm">
                    <mat-form-field appearance="outline" matTooltip="{{'DateReceived' | translate}}">
                      <mat-label>{{'Choose a date' | translate}}</mat-label>
                      <input matInput [disabled]="ocRcButtonEnable" [min]="minDate" [max]="maxDate"  [matDatepicker]="picker"
                        formControlName="receivedDate"
                        >
                      @if (!ocRcButtonEnable) {
                        <mat-datepicker-toggle  matSuffix [for]="picker" class="padding: unset !important;"></mat-datepicker-toggle>
                      }
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </form>

                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-sm-4 dcn-resolution1" >
          <div class="text-right" >
            <button (click)="openDialog()" mat-raised-button >{{'Back to Summary' | translate}}</button>
          </div>

          &nbsp;&nbsp;
          <div class="text-right" ></div>

          &nbsp;&nbsp;
          <div class="text-right" ></div>

          &nbsp;&nbsp;
          <div class="text-right" ></div>
          &nbsp;
          @if (orderdetailsresponse.status === 4 || orderdetailsresponse.status === 5) {
            <div class=" text-right">
              <button mat-icon-button  matTooltip="{{'Signed PDF Report ' | translate}}" (click)="openReportPDF()">
                <mat-icon>cloud_download</mat-icon>
              </button>
            </div>
          }
        </div>

      </div>
    </div>
    <div class="box-body ml-2 mr-2">
      <mat-table [dataSource]="orderdetailsresponse.orderDetailsDtoList" class="order-summary-table mat-elevation-z8" matSort (matSortChange)="sortData($event)">
        <!-- Position Column -->
        <ng-container matColumnDef="itemDescription">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Product Description' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.itemDescription }} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="orderedquantity">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Order Qty' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" >
            @if (!viewDetailsEnable) {
              <label>{{ element.orderedQuantity }}</label>
            }
            @if (viewDetailsEnable) {
              <label>{{'OC not yet received'| translate}} </label>
            }
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="quantity">
          <mat-header-cell *matHeaderCellDef mat-sort-header > {{'Shipped Qty' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" > {{ element.quantity }} </mat-cell>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="itemNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'UPC' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.itemNumber}} </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="din">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'DIN' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.din?  element.din : '--' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="orderunit">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Pack Size' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.packageSize ? element.packageSize : '--' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="discrepancy">
          <mat-header-cell matTooltip="{{'Discrepancy_Tool_Tip' | translate}}" *matHeaderCellDef> {{'Discrepancy?' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" matTooltip="{{'Discrepancy_Tool_Tip' | translate}}">
            @if (element.reason===null && !ocRcButtonEnable) {
              <button style="margin-left: -17px;" (click)="updateDiscrepancy(element.sequenceNumber,element)" [disabled]="viewDetailsEnable" mat-button >{{'Update/Report' | translate}}</button>
            }
            @if (ocRcButtonEnable) {
              <button style="margin-left: -17px;" (click)="updateDiscrepancy(element.sequenceNumber,element)" [disabled]="viewDetailsEnable" mat-button >{{'View Details' | translate}}</button>
            }
            @if (element.reason!==null && !ocRcButtonEnable) {
              <button style="margin-left: -17px;" (click)="updateDiscrepancy(element.sequenceNumber,element)" [disabled]="viewDetailsEnable" mat-button >{{'Updated' | translate}}</button>
            }
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>



    </div>
    <div class="row box-footer text-right px-3 py-2">
      @if (!ocRcButtonEnable) {
        <div class="col text-left" >
          <p>
            {{'RC Approval Msg' | translate}}
          </p>
        </div>
      }
      <div class="col" >

        @if (!ocRcButtonEnable) {
          <button mat-raised-button color="primary" [disabled]="!rcSummaryForm.valid || ocRcButtonEnable || viewDetailsEnable" (click)="approveRC()">{{'Approve' | translate}}</button>
        }
      </div>
    </div>

  </div>
</block-ui>
